import React from 'react'
import { connect } from 'redaction'

import OverlayLoader from 'components/loaders/OverlayLoader/OverlayLoader'


const RequestLoader = ({ isVisible }) => (
  <OverlayLoader isVisible={isVisible} name="requestLoader" />
)

export default connect({
  isVisible: 'models.ui.isRequestLoaderVisible',
})(RequestLoader)
